<div>
    <iui-messages #messages class="ms-auto me-auto"></iui-messages>
</div>

<div *ngIf="isDisplayReady && totalRecords>0">
    <div class="search-input-group col-3 ps-0">
        <input id="accountId" class="form-control form-text" name="scId" minlength="7" type="text" onkeypress='return event.charCode >= 48 && event.charCode <= 57' #scId="ngModel"
            [(ngModel)]="searchValue" placeholder="Search Invoice ID">
        <button *ngIf="searchValue" type="button" class="search-button me-5" (click)="searchInvoice()">
            <i class="fa fa-magnifying-glass"></i>
        </button>
        <button *ngIf="searchValue" type="button" class="search-button me-2 ">
            <i class="fas fa-circle-xmark" (click)="clearSearch()"></i>
        </button>
    </div>
    <div *ngIf=" isSearchError" class="row ms-0 ">
        <span class="inline-error-text">Invoice ID must be at least 7 digits long</span>
    </div>
    <p-table #tt styleClass="p-datatable-striped" id="tt" [value]="monthlyInvoiceList" dataKey="monthlyInvoiceId" *ngIf="monthlyInvoiceList.length !== 0" [paginator]="true"
        placeholder="Invoice ID" sortField="monthlyInvoiceId" sortMode="single" [filterDelay]="0" [sortOrder]="-1" [alwaysShowPaginator]="false" [rows]="5"
        currentPageReportTemplate="(Displaying {first} to {last} of {totalRecords})" [showCurrentPageReport]="true" [lazy]="true" (onPage)="loadLazyInvoiceLoad($event)"
        [totalRecords]='totalRecords'>
        <!-- Template paginatorright as a hacky way to add spacing. DO NOT REMOVE!!! -->
        <ng-template pTemplate="paginatorright" let-state></ng-template>
        <ng-template pTemplate="header" let-invoice>
            <tr class="mt-3">
                <th class="small-column-flex-override"></th>
                <th *ngFor="let col of invoiceColumns">
                    <ng-container>
                        {{col.header}}
                    </ng-container>
                </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-invoice let-expanded="expanded">
            <tr>
                <td class="small-column-flex-override">
                    <button type="button" pButton class="p-button-text p-button-rounded p-button-plain" [icon]="expanded ? 'fas fa-minus' : 'fas fa-plus'"
                        (click)="expansionShowHide(invoice.monthlyInvoiceId)" pButton pRipple [pRowToggler]="invoice">
                    </button>
                </td>
                <td>{{invoice.monthlyInvoiceId}}</td>
                <td>{{invoice.invoiceStatus | orderStatus }}</td>
                <td>{{invoice.numberOfCodes }}</td>
                <td>{{invoice.totalPrice | currency }}</td>
                <td>{{invoice.invoiceDate| date:'M/d/yyyy' }}</td>
                <td>{{invoice.paymentDueDate| date:'M/d/yyyy' }}</td>
                <td>{{invoice.paymentReceivedDate | date:'M/d/yyyy' }}</td>
                <td>{{invoice.paymentMethod}}</td>
                <!-- TODO: Write a function to pick the correct click event for Action -->
                <td>
                    <button *ngIf="invoice.invoiceStatus === 'PaymentDue' || invoice.invoiceStatus === 'PaymentOverdue'" class="btn btn-primary btn-sm"
                        (click)="viewInvoice(invoice.monthlyInvoiceId)">View/Pay Invoice</button>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="rowexpansion" let-invoiceexpand>
            <tr style="padding-left: 100px;">
                <td [attr.colspan]="10" class="ps-5">
                    <div class="row">
                        <div class="col-4">Billing Contact: {{ invoiceexpand.billingFirstName }} {{
                            invoiceexpand.billingLastName }}
                        </div>
                        <div class="col-4 truncate" tooltipPosition="top" [pTooltip]="invoiceexpand.billingEmail || ''">
                            Email: {{ invoiceexpand.billingEmail }}</div>
                        <div class="col-4">
                            <a class="link" *ngIf="invoiceexpand.invoiceStatus === 'Paid' || invoiceexpand.invoiceStatus === 'AutoPay'"
                                (click)="viewInvoice(invoiceexpand.monthlyInvoiceId)">View Monthly Invoice</a>
                            &nbsp;
                            <a class="link" *ngIf="invoiceexpand.invoiceStatus === 'Paid'" (click)="viewReceipt(invoiceexpand.monthlyInvoiceId)">View Monthly Receipt</a>
                        </div>
                    </div>
                </td>
            </tr>
            <tr *ngIf="invoiceexpand.isExpansionDisplay">
                <td colspan="10" class="ps-5">
                    <p-table styleClass="p-datatable-striped" #shortCodes id="shortCodes" [value]="invoiceexpand.lines" [sortOrder]="1" sortField="scId"
                        *ngIf="invoiceexpand.lines?.length !== 0" [scrollable]="true" scrollHeight="50vh">
                        <ng-template pTemplate="header" let-invoice>
            <tr>
                <th *ngFor="let col of expandedInvoiceColumns" [ngSwitch]="col.sorting">
                    <ng-container *ngSwitchDefault>
                        {{col.header}}
                    </ng-container>
                </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-shortCode>
            <tr>
                <td><a class="link" (click)="viewShortCode(shortCode.scId)">{{shortCode.scId}}</a></td>
                <td>{{shortCode.startDate| date:'M/d/yyyy' }}</td>
                <td>{{shortCode.endDate| date:'M/d/yyyy' }}</td>
                <td>{{shortCode.selectType }}</td>
                <td>{{shortCode.price | scrMoney }}</td>
                <td> <a class="link" (click)="navigateByLeaseOrderId(shortCode.leaseOrderId,shortCode.scId)">{{shortCode.leaseOrderId}}</a>
                </td>
                <td>{{shortCode.leaseEndDate| date:'M/d/yyyy' }}</td>
                <td>{{shortCode.leaseMonth}}</td>
            </tr>
        </ng-template>
    </p-table>
    </td>
    </tr>
    </ng-template>
    </p-table>
</div>
<div *ngIf="totalRecords===0">
    <table>
        <tr>
            <td class="noBorder">
                No invoices were found.
            </td>
        </tr>
    </table>
</div>

<p-confirmDialog key='shortCodeHistoryNavigation' #shortCodeHistoryNavigation width="425" [closable]="false">
    <p-footer>
        <button i18n id="canAccept" class="btn btn-primary me-2" (click)="shortCodeHistoryNavigation.accept()">Yes</button>
        <button i18n id="canReject" class="btn btn-secondary" (click)="shortCodeHistoryNavigation.reject()">No</button>
    </p-footer>
</p-confirmDialog>